export const delayService: number = 400;
export const delayBooking: number = 800;
